// Use Netlify function as proxy to avoid CORS issues
const CLAUDE_API_URL = '/.netlify/functions/claude-api';

export async function getClaudeAdvice(workoutHistory, currentWorkout, userProfile) {
  const prompt = buildWorkoutPrompt(workoutHistory, currentWorkout, userProfile);

  try {
    const response = await fetch(CLAUDE_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        model: 'claude-3-5-sonnet-20241022',
        max_tokens: 1024,
        messages: [
          {
            role: 'user',
            content: prompt
          }
        ]
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to get advice from Claude');
    }

    const data = await response.json();
    return data.content[0].text;
  } catch (error) {
    console.error('Claude API error:', error);
    throw error;
  }
}

function buildWorkoutPrompt(workoutHistory, currentWorkout, userProfile) {
  return `You are a personal fitness coach helping Jesse with his strength training program.

**Jesse's Profile:**
- 42-year-old male, 5'10", 175 lbs, 20% body fat
- Lost 60 lbs over the past year (233 → 175 lbs)
- Former military, getting back into shape
- Current fitness: 2-3 pull-ups, 10-15 push-ups
- 12-week goals:
  * Pull-ups: 3 → 10 strict pull-ups
  * Push-ups: 15 → 30 in one set
  * Body fat: 20% → 15%
  * Build functional muscle (arms, chest, shoulders, glutes, thighs)

**Current Workout:**
${currentWorkout.name} - ${currentWorkout.focus}
Location: ${currentWorkout.location}

**Recent Workout History:**
${formatWorkoutHistory(workoutHistory)}

**Your Task:**
Analyze Jesse's recent workout data and provide:
1. **Progressive Overload Recommendations** - Specific weight/rep targets for today's workout
2. **Form & Technique Tips** - Key focus points for his current exercises
3. **Recovery & Intensity Advice** - Based on his difficulty ratings, is he pushing too hard or not enough?
4. **Goal Progress Check** - How is he tracking toward his 12-week goals?

Keep your response concise, actionable, and motivating. Focus on practical advice he can use right now at the gym.`;
}

function formatWorkoutHistory(history) {
  if (!history || history.length === 0) {
    return 'No previous workout data available.';
  }

  return history.slice(-4).map(workout => {
    const exerciseSummary = workout.exercises.map(ex => {
      const setsSummary = ex.sets && ex.sets.length > 0
        ? ex.sets.map(s => `${s.weight}lbs × ${s.reps}`).join(', ')
        : 'Not logged';
      const difficulty = ex.difficulty ? `Difficulty: ${ex.difficulty}/10` : 'No difficulty rating';
      return `  - ${ex.name}: ${setsSummary} | ${difficulty}`;
    }).join('\n');

    return `${workout.date} - ${workout.workoutName}\n${exerciseSummary}`;
  }).join('\n\n');
}
